export default function() {
  $('.clickAction[data-action="totop"]').parent().click(function(e){
    e.preventDefault();
      var sTop = 0;
      $('html, body').animate(
         {scrollTop:sTop},500
      );
  });
  
  $('.clickAction[data-action="backpage"]').parent().click(function(e){
    e.preventDefault();
      window.history.go(-1);
  });
}